// Miroir des tarifs par défaut du serveur (GET /api/stage-pricing fait foi pour les formulaires).
export const STAGE_PRICING = {
  groupe: 400,
  groupeSpecial: 500,
  editionSpeciale: 600,
  individuel: 500,
  privatise4: 450,
  exterieur: 600,
  domicile: 100,
};

export const STAGE_SUPPLEMENTS = { peauxPremium: 100, diametresHorsStandard: 50, diametreAutre: 100 };

export const STAGE_PAGE = "/offres/stage-fabrication-tambour";
export const stageBookingPath = (eventId) => `${STAGE_PAGE}${eventId ? `?event=${eventId}` : ""}#reserver`;

export const stageEventKind = (event) => {
  const formule = event?.stage_formule || (event?.edition_speciale ? (/super lune/i.test(event?.titre || "") ? "super_lune" : "special") : "classique");
  return { classique: "groupe", special: "groupe_special", super_lune: "super_lune" }[formule];
};

export const individualKind = (formule, participants) => (formule === "exterieur" ? "exterieur" : participants >= 4 ? "privatise_4" : "individuel");

export const optionFormat = (kind) => ({ groupe: "groupe", groupe_special: "groupe", super_lune: "super_lune" }[kind] || "individuel");
